// Damaged Products Vuex

import state from './destructedAssetStates.js'
import * as getters from './destructedAssetGetters.js'
import * as mutations from './destructedAssetMutations.js'
import * as actions from './destructedAssetActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
